(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    const panel = drawer.querySelector('[data-cart-panel]');
    let lastFocused = null;

    const focusables = () => panel.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      const f = focusables();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      drawer.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastFocused) lastFocused.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...focusables()];
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* Quantity, without leaving the bag.
     *
     * THE SERVER RE-RENDERS THIS SECTION, it is not rebuilt here. Shopify's
     * cart AJAX endpoints take a `sections` list and hand back the rendered
     * HTML, so the meter, the marks, the subtotal and the checkout label are
     * all recomputed by the same Liquid that drew them the first time. Writing
     * a second copy of those rules in JavaScript is how the two surfaces drift
     * apart, and this bag has three numbers on it that must agree with checkout.
     *
     * Only the panel's contents are swapped, never the drawer element itself:
     * the section always renders with `hidden` on it, so replacing the whole
     * thing would slam the bag shut on every click of plus. */
    const SECTION = 'cart-drawer';
    let busy = false;

    async function setLine(line, quantity) {
      // There is no cart endpoint to post to unless Shopify is serving this.
      // The static harness opens the same markup over file://, where asking
      // would only log a failure the shopper will never see.
      if (!location.protocol.startsWith('http')) return;
      if (busy) return;
      busy = true;
      panel.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION }),
        });
        if (!res.ok) return;
        const data = await res.json();
        const html = data.sections && data.sections[SECTION];
        if (html) {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-panel]');
          if (fresh) {
            panel.innerHTML = fresh.innerHTML;
            dispatchTick();
          }
        }
        // The header badge is rendered by another section and is not in the
        // HTML we just swapped, so it is updated from the count in the reply.
        const badge = document.querySelector('[data-cart-count]');
        if (badge) {
          if (data.item_count > 0) badge.textContent = data.item_count;
          else badge.remove();
        }
      } catch (err) {
        // A change that does not reach Shopify leaves the bag exactly as it
        // was, which is the honest outcome: the drawer must never show a
        // quantity the cart does not hold. Nothing is thrown on, because an
        // unhandled rejection here would surface as a page error for a
        // shopper whose connection dropped for a second.
      } finally {
        busy = false;
        panel.removeAttribute('aria-busy');
      }
    }

    /* Adding a cup opens the bag instead of loading the cart page.
     *
     * THE PAGE THE OWNER ASKED TO REMOVE. Until now Add to Cart was a plain
     * form post: Shopify took the line, then redirected to /cart, so a shopper
     * who wanted one cup was moved off the product page to a page that showed
     * them the same bag the drawer shows — with the drawer sitting right there
     * unused. Now the add happens where they are and the bag slides out over it.
     *
     * THE SAME RE-RENDER setLine uses. /cart/add.js takes a `sections` list and
     * hands back the drawer's HTML rendered against the new cart, so the meter,
     * the marks, the subtotal and the checkout label come from the same Liquid
     * that drew them the first time rather than a second copy of those rules.
     *
     * IF ANY OF IT FAILS, THE FORM STILL POSTS. preventDefault happens only
     * once the fetch has succeeded — a dropped connection, a sold-out variant,
     * a browser with the script off, and the shopper gets the old behaviour,
     * which is a working add and the cart page. The one control on this store
     * that takes money does not get a fast path that can swallow it.
     */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form || !location.protocol.startsWith('http')) return;
      if (form.dataset.cartPosting === 'yes') return;

      e.preventDefault();
      form.dataset.cartPosting = 'yes';

      const body = new FormData(form);
      body.append('sections', SECTION);

      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then((res) => (res.ok ? res.json() : Promise.reject(res)))
        .then((data) => {
          const html = data.sections && data.sections[SECTION];
          if (html) {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-panel]');
            if (fresh) { panel.innerHTML = fresh.innerHTML; dispatchTick(); }
          }
          // The badge lives in the header, which is not in the HTML just
          // swapped, and /cart/add.js reports the line rather than the cart —
          // so the count is read from the cart itself.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((cart) => {
              const badge = document.querySelector('[data-cart-count]');
              if (badge) badge.textContent = cart.item_count;
              open();
            });
        })
        .catch(() => {
          // Hand it back to the browser: a real submit, a real add, the cart
          // page. Slower and correct beats quick and lost.
          form.submit();
        })
        .finally(() => { delete form.dataset.cartPosting; });
    });

    document.addEventListener('click', (e) => {
      const step = e.target.closest('[data-cart-line]');
      if (step) {
        e.preventDefault();
        const line = Number(step.getAttribute('data-cart-line'));
        const to = Number(step.getAttribute('data-cart-to'));
        // THE SAME CONTROLS ON TWO SURFACES. Inside the drawer the section is
        // re-rendered in place. On the /cart page there is no drawer to
        // re-render, so the page is reloaded once the change has landed —
        // which is still one tap and no Update button. If the script is not
        // running at all, the controls are plain links to Shopify's own
        // /cart/change route and the page reloads by itself.
        if (panel.contains(step)) setLine(line, to);
        else setLine(line, to).then(() => window.location.reload());
        return;
      }

      const opener = e.target.closest('[data-cart-open]');
      if (opener) {
        // Add to Cart is a submit button, and the submit handler above opens
        // the bag itself once the line has actually landed. Opening it here as
        // well would show the shopper the bag WITHOUT the cup they just added,
        // for as long as the request takes — the one moment they are looking
        // for it. Cancelling the click is also not an option: that would cancel
        // the post. So a submitting opener is left entirely alone here.
        if (opener.type === 'submit') return;
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
    });

    /* The dispatch line, on the product page's rules exactly.
     *
     * Melbourne's clock, not the reader's — the cut-off is an hour in the
     * warehouse. Weekday and before the hour, it counts; otherwise the line
     * is not shown at all, rather than counting down to a deadline that has
     * already gone. It ships hidden and is only ever revealed by this, so a
     * reader with no JavaScript is told nothing instead of something untrue.
     *
     * The element is looked up fresh each tick because a quantity change
     * replaces it along with the rest of the panel. */
    /* "2h 13m", not "02:13:00".
     *
     * THE TWO CLOCKS IN THIS STORE READ DIFFERENTLY ON PURPOSE, because the
     * reference's do: their product page counts in hours:minutes:seconds and
     * their bag rounds to hours and minutes. It is the right call either way —
     * a ticking second-hand beside a product is urgency, and the same thing
     * beside a bag you are about to pay for is noise. The last minute counts
     * in seconds so the line never reads "0m". */
    function human(left) {
      const h = Math.floor(left / 3600);
      const m = Math.floor(left / 60) % 60;
      if (h > 0) return `${h}h ${m}m`;
      if (m > 0) return `${m}m`;
      return `${left % 60}s`;
    }

    /* Seconds left until midnight where the shopper is sitting.
     *
     * The reader's own clock, deliberately — this is the reference's rule,
     * measured from their bag rather than assumed, and asked for by the owner.
     * setHours(24, 0, 0, 0) is the start of the next local day, so daylight
     * saving is the browser's problem rather than ours. */
    function toMidnight() {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return Math.max(0, Math.floor((midnight - now) / 1000));
    }

    /* The day the parcel lands, if it is ordered before that midnight.
     *
     * Two business days are stepped, not one: the order joins the NEXT business
     * day's run — nothing packed tonight — and Express Post then undertakes the
     * business day after that inside Australia Post's metro network. Ordering
     * on a Monday therefore names Wednesday, which is the day the reference
     * named on a Monday; where theirs still says Wednesday at ten past midnight
     * on Tuesday, this says Thursday, because by then Wednesday has stopped
     * being true. */
    function arrivalDay() {
      const step = (d) => {
        do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
        return d;
      };
      const d = step(step(new Date()));
      return new Intl.DateTimeFormat('en-AU', { weekday: 'long' }).format(d);
    }

    /* Every dispatch line on the page, not just the drawer's: this section
     * ships on every template, so the same loop drives the /cart page's copy
     * of the line without a second script to keep in step. Looked up fresh
     * each tick because a quantity change replaces the drawer's. */
    function dispatchTick() {
      const rows = document.querySelectorAll('[data-cart-countdown]');
      if (!rows.length) return;
      const left = toMidnight();
      const day = arrivalDay();
      rows.forEach((row) => {
        row.hidden = false;
        row.textContent = (row.getAttribute('data-cart-before') || '')
          .replace('{time}', human(left))
          .replace('{day}', day);
      });
    }

    dispatchTick();
    setInterval(dispatchTick, 1000);
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"]) return;
  try {
    
  (function () {
    // Swatches scroll to their card. Prefers smooth motion but honours
    // prefers-reduced-motion via the media query in base.css.
    document.addEventListener('click', (e) => {
      const el = e.target.closest('[data-scroll-to]');
      if (!el) return;
      const target = document.getElementById(el.getAttribute('data-scroll-to'));
      if (!target) return;           // no card for this colour: let the href stand
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-section="header"]');
    if (!header) return;
    /*
     * More than one panel now, so a toggle is paired with its panel by key
     * rather than by being the only one on the page. Opening one closes any
     * other: two panels open at once would overlap, since both are absolutely
     * positioned under the header band.
     */
    const megas = [...header.querySelectorAll('[data-mega-toggle]')]
      .map((btn) => ({ btn, panel: header.querySelector(`[data-mega-panel="${btn.dataset.megaToggle}"]`) }))
      .filter((m) => m.panel);

    const closeMegas = (except) => {
      for (const m of megas) {
        if (m === except) continue;
        m.panel.hidden = true;
        m.btn.setAttribute('aria-expanded', 'false');
      }
    };

    const setMegaOpen = (m, open) => {
      if (open) closeMegas(m);
      m.panel.hidden = !open;
      m.btn.setAttribute('aria-expanded', String(open));
    };

    const anyMegaOpen = () => megas.some((m) => !m.panel.hidden);

    for (const m of megas) {
      m.btn.addEventListener('click', (e) => {
        // The trigger is a real link so it still works without this script.
        // Leave modified clicks alone: ctrl/cmd/shift/middle should open the
        // destination the way the shopper asked for, not swallow the click.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        setMegaOpen(m, m.panel.hidden);
      });
    }

    // Search panel. Focus goes into the field on open and back to the button
    // on close, so it is usable without a mouse.
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchPanel = header.querySelector('[data-search-panel]');
    const searchInput = header.querySelector('[data-search-input]');

    const setSearchOpen = (open) => {
      if (!searchPanel || !searchToggle) return;
      searchPanel.hidden = !open;
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open && searchInput) searchInput.focus();
      else if (!open) searchToggle.focus();
    };

    // Mobile menu. Same shape as the search panel above it, and the two close
    // each other: they drop into the same place under the header, so both open
    // at once would stack one on the other.
    const menuToggle = header.querySelector('[data-menu-toggle]');
    const menuPanel = header.querySelector('[data-menu-panel]');

    const setMenuOpen = (open) => {
      if (!menuPanel || !menuToggle) return;
      menuPanel.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
      // Focus the first link on open so a keyboard lands inside the menu it
      // just asked for; back to the button on close so the place is kept.
      if (open) menuPanel.querySelector('a')?.focus();
      else menuToggle.focus();
    };

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', () => {
        closeMegas();                        // never a mega and search at once
        if (menuPanel && !menuPanel.hidden) setMenuOpen(false);
        setSearchOpen(searchPanel.hidden);
      });
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !searchPanel.hidden) setSearchOpen(false);
      });
      document.addEventListener('click', (e) => {
        if (!searchPanel.hidden && !header.contains(e.target)) searchPanel.hidden = true;
      });
    }

    if (menuToggle && menuPanel) {
      menuToggle.addEventListener('click', () => {
        closeMegas();
        if (searchPanel && !searchPanel.hidden) setSearchOpen(false);
        setMenuOpen(menuPanel.hidden);
      });
      header.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !menuPanel.hidden) setMenuOpen(false);
      });
      document.addEventListener('click', (e) => {
        if (!menuPanel.hidden && !header.contains(e.target)) menuPanel.hidden = true;
      });
    }

    // Escape closes and returns focus to the control that opened it.
    header.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = megas.find((m) => !m.panel.hidden);
      if (open) { setMegaOpen(open, false); open.btn.focus(); }
    });

    // Closing on outside click keeps a panel from trapping the page.
    document.addEventListener('click', (e) => {
      if (anyMegaOpen() && !header.contains(e.target)) closeMegas();
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-widget"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-help-widget]');
    if (!root) return;
    var toggle = root.querySelector('[data-help-toggle]');
    var panel = root.querySelector('[data-help-panel]');
    var thread = root.querySelector('[data-help-thread]');
    var form = root.querySelector('[data-help-form]');
    var input = root.querySelector('[data-help-input]');
    var expand = root.querySelector('[data-help-expand]');
    if (!toggle || !panel || !thread || !form || !input) return;

    /* The answers, read off the chips the template already rendered, so this
     * script never carries a second copy of the support text that could drift
     * from content.json. */
    var QA = [].slice.call(root.querySelectorAll('[data-help-ask]')).map(function (b) {
      return { q: b.getAttribute('data-help-ask'), a: b.getAttribute('data-help-answer') };
    });

    var STOP = ['what', 'when', 'where', 'which', 'does', 'do', 'is', 'are', 'the', 'a', 'an',
      'my', 'your', 'i', 'you', 'can', 'will', 'it', 'to', 'for', 'of', 'and', 'how', 'about'];

    var words = function (s) {
      return String(s).toLowerCase().split(/[^a-z0-9$]+/).filter(function (t) {
        return t.length > 2 && STOP.indexOf(t) === -1;
      });
    };

    /* Score by how many of the asker's words appear in the question or the
     * answer. Deliberately dumb and deliberately honest: below a threshold it
     * says it does not know rather than returning the least-bad paragraph. */
    var match = function (text) {
      var terms = words(text);
      if (!terms.length) return null;
      var best = null;
      var bestScore = 0;
      QA.forEach(function (item) {
        var hay = (item.q + ' ' + item.a).toLowerCase();
        var score = 0;
        terms.forEach(function (t) { if (hay.indexOf(t) !== -1) score += 1; });
        if (score > bestScore) { bestScore = score; best = item; }
      });
      return bestScore > 0 ? best : null;
    };

    var bubble = function (text, mine) {
      var row = document.createElement('div');
      row.className = 'helpw__msg' + (mine ? ' helpw__msg--you' : '');
      if (!mine) {
        var av = root.querySelector('.helpw__msg-avatar');
        if (av) row.appendChild(av.cloneNode(true));
      }
      var p = document.createElement('p');
      p.className = 'helpw__bubble';
      p.textContent = text;
      row.appendChild(p);
      thread.appendChild(row);
      thread.scrollTop = thread.scrollHeight;
    };

    var ask = function (text) {
      var q = String(text || '').trim();
      if (!q) return;
      bubble(q, true);
      var hit = match(q);
      bubble(hit ? hit.a : form.getAttribute('data-no-match') || '', false);
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      ask(input.value);
      input.value = '';
      input.focus();
    });

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-help-ask]');
      if (chip) ask(chip.getAttribute('data-help-ask'));
    });

    var setOpen = function (open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) input.focus();
      else toggle.focus();
    };

    toggle.addEventListener('click', function () { setOpen(panel.hidden); });
    root.querySelectorAll('[data-help-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });

    /* The prompt above the launcher. Shown once per tab: its own close hides it,
     * and so does opening the panel, because by then it has done its job.
     * sessionStorage rather than localStorage, so it returns for a new visit
     * rather than never again — and every read and write is wrapped, because a
     * browser set to block site data throws on access rather than returning
     * null, and a card that cannot remember being dismissed is still better
     * than a script that dies trying. */
    var prompt = root.querySelector('[data-help-prompt]');
    if (prompt) {
      var PROMPT_KEY = 'macha:help-prompt';
      var seen = false;
      try { seen = sessionStorage.getItem(PROMPT_KEY) === 'dismissed'; } catch (e) { seen = false; }
      prompt.hidden = seen;

      var dismissPrompt = function () {
        prompt.hidden = true;
        try { sessionStorage.setItem(PROMPT_KEY, 'dismissed'); } catch (e) { /* blocked */ }
      };

      var promptClose = prompt.querySelector('[data-help-prompt-close]');
      var promptOpen = prompt.querySelector('[data-help-prompt-open]');
      if (promptClose) promptClose.addEventListener('click', dismissPrompt);
      if (promptOpen) {
        promptOpen.addEventListener('click', function () { dismissPrompt(); setOpen(true); });
      }
      toggle.addEventListener('click', dismissPrompt);
    }

    if (expand) {
      expand.addEventListener('click', function () {
        var on = !panel.hasAttribute('data-expanded');
        if (on) panel.setAttribute('data-expanded', ''); else panel.removeAttribute('data-expanded');
        expand.setAttribute('aria-pressed', String(on));
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !root.contains(e.target)) setOpen(false);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-reviews"]) return;
  try {
    
  /*
   * The row's controls. Three jobs and nothing else:
   *
   *   1. Show the pair only when there is something to scroll. Sixteen cards
   *      overflow at every width today, but the count is content — drop back to
   *      four and the buttons should disappear rather than sit there dead.
   *   2. Move by ONE CELL, measured off the first cell rather than typed in, so
   *      the step stays right when the cell width changes at a breakpoint.
   *   3. Disable at the ends, so a reader can tell where they are.
   *
   * The row scrolls without any of this — overflow-x, arrow keys, a trackpad
   * swipe. This is the affordance, not the mechanism.
   */
  (function () {
    document.querySelectorAll('.hrev').forEach(function (band) {
      var row = band.querySelector('.hrev__row');
      var controls = band.querySelector('[data-hrev-controls]');
      if (!row || !controls) return;

      var buttons = controls.querySelectorAll('[data-hrev-scroll]');

      function step() {
        var cell = row.querySelector('.hrev__cell');
        // offsetWidth carries the cell's own padding, which is the gap between
        // neighbours, so one cell is one pitch.
        return cell ? cell.offsetWidth : row.clientWidth;
      }

      function sync() {
        var overflow = row.scrollWidth - row.clientWidth;
        // A pixel of slack: sub-pixel layout leaves rows that do not overflow
        // reporting 0.5 and growing a pair of buttons that do nothing.
        controls.hidden = overflow <= 1;
        if (controls.hidden) return;
        var x = row.scrollLeft;
        buttons.forEach(function (b) {
          var dir = Number(b.getAttribute('data-hrev-scroll'));
          b.disabled = dir < 0 ? x <= 1 : x >= overflow - 1;
        });
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          row.scrollBy({ left: Number(b.getAttribute('data-hrev-scroll')) * step(), behavior: 'smooth' });
        });
      });

      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notify-modal"]) return;
  try {
    
  (function () {
    const modal = document.querySelector('[data-notify]');
    if (!modal) return;
    const panel = modal.querySelector('[data-notify-panel]');
    const tagField = modal.querySelector('[data-notify-tag]');
    const colourLabel = modal.querySelector('[data-notify-colour-label]');
    const prefix = modal.getAttribute('data-tag-prefix') || 'notify:';
    let lastFocused = null;

    const focusables = () => panel.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    function open(colour) {
      lastFocused = document.activeElement;
      if (tagField) tagField.value = prefix + colour;
      if (colourLabel) colourLabel.textContent = colour;
      modal.hidden = false;
      const f = focusables();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (lastFocused) lastFocused.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...focusables()];
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-notify-open]');
      if (trigger) { e.preventDefault(); open(trigger.getAttribute('data-notify-open')); return; }
      if (e.target.closest('[data-notify-close]')) { e.preventDefault(); close(); }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  /* The sticky buy bar: visible only while the real button is off screen.
   *
   * FIRST IN THE FILE, DELIBERATELY. Shopify compiles every section's script
   * block into one bundle and wraps each section's share of it in a single
   * try/catch, so the blocks inside it run in order and the FIRST one to throw
   * takes every later one down with it. This shipped at the bottom on
   * 2026-09-26 and never ran on the live store for exactly that reason — the
   * same code pasted into the console worked immediately. The control that
   * takes money does not queue behind the gallery and a clock.
   *
   * An IntersectionObserver on the Add to Cart itself, not a scroll position.
   * A pixel threshold would be wrong the moment the page above it changes
   * height — a longer intro, a wrapped heading, a colour with a second
   * photograph — and wrong differently at every width. Watching the button
   * makes the rule the sentence the owner asked for: the bar is there when the
   * button is not.
   *
   * ONLY WHEN THE BUTTON IS ABOVE. Scrolling back up, the button leaves the
   * viewport downwards, and a bar appearing then would offer a control the
   * reader can see just below it. */
  (function () {
    // A SCROLL LISTENER, NOT AN IntersectionObserver, and that is a retreat.
    //
    // The observer version was correct as written and worked when pasted into
    // the console of the live page, but attached to nothing when the theme ran
    // it — proved by un-hiding the bar by hand and scrolling back to the top,
    // where a live observer would have re-hidden it and none did. The section's
    // block was demonstrably alive at the time (the dispatch countdown two
    // functions later was re-hiding its own row on a one-second timer), so the
    // cause is something about observing this element at this moment that
    // cannot be seen from outside the browser.
    //
    // Reading the rectangle on scroll has none of that: no registration to
    // lose, no lifetime to keep, no callback that may or may not fire. It is
    // measurably more work than an observer, which is why the read is throttled
    // to one animation frame and both listeners are passive — at which point it
    // costs a `getBoundingClientRect` per frame while scrolling, and nothing at
    // all when still.
    const bar = document.querySelector('[data-sticky-buy]');
    const atc = document.querySelector('.pmain__atc');
    if (!bar || !atc) return;

    let queued = false;

    const measure = () => {
      queued = false;
      // Past it, not merely off the top of the first screen: the buy panel is
      // sticky from 1024 up, so the button travels with the reader and only
      // leaves the viewport when the gallery beside it runs out.
      const past = atc.getBoundingClientRect().bottom < 0;
      if (past === !bar.hidden) return;
      bar.hidden = !past;
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(measure);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    measure();
  }());

  (function () {
    const gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-thumb]');
      if (!t) return;
      const slide = document.getElementById('pslide-' + t.getAttribute('data-thumb'));
      if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
  }());

  /* The dispatch countdown.
   *
   * MELBOURNE TIME, NOT THE READER'S. The cut-off is an hour in the warehouse,
   * so a shopper in Perth has to be told how long is left THERE, not on their
   * own clock. Intl gives the Melbourne wall clock wherever the browser sits.
   *
   * It counts to today's cut-off only while today is a weekday and the hour has
   * not passed. Otherwise it says which day the parcel leaves instead — a
   * countdown that keeps running past its own deadline is the fake-urgency
   * version of this control, and the copy for both states is content, so the
   * owner can change what is promised without touching this. */
  (function () {
    const row = document.querySelector('[data-cutoff]');
    if (!row) return;
    const out = row.querySelector('[data-cutoff-text]');
    const [h, m] = (row.getAttribute('data-cutoff') || '').split(':').map(Number);
    const before = row.getAttribute('data-before') || '';
    const after = row.getAttribute('data-after') || (out ? out.textContent : '');
    if (!out || Number.isNaN(h)) return;

    const melbourne = () => {
      const f = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Melbourne',
        hour12: false,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).formatToParts(new Date());
      const get = (t) => f.find((p) => p.type === t).value;
      return { day: get('weekday'), h: +get('hour'), m: +get('minute'), s: +get('second') };
    };

    const pad = (n) => String(n).padStart(2, '0');

    /* TODAY'S CUT-OFF, OR NOTHING — the reference's own rule, worked out by
     * watching their page rather than guessing. Their line read "cut off in
     * 13:47:00" in a shot taken after midnight, counting to that same day's
     * hour; at 22:53 on a Monday their product page showed no dispatch line at
     * all. So the row exists only while an order placed NOW still makes today's
     * van, and disappears the rest of the time rather than counting down to a
     * deadline fifteen hours away, which is a clock, not urgency.
     *
     * Ours does the same: weekday and before the hour, it counts; otherwise the
     * row is removed. The markup ships with the next-business-day line as its
     * text, so a reader with no JavaScript gets a true sentence instead of a
     * blank space. */
    function tick() {
      const now = melbourne();
      const weekday = now.day !== 'Sat' && now.day !== 'Sun';
      const left = (h * 3600 + m * 60) - (now.h * 3600 + now.m * 60 + now.s);
      if (!weekday || left <= 0) {
        row.hidden = true;
        return;
      }
      row.hidden = false;
      const time = `${pad(Math.floor(left / 3600))}:${pad(Math.floor(left / 60) % 60)}:${pad(left % 60)}`;
      out.textContent = before.replace('{time}', time);
    }

    tick();
    setInterval(tick, 1000);
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-promo"]) return;
  try {
    
  // The bar ships hidden and is shown by script, so a dismissed promo never
  // flashes up before the storage read. No script, no bar: a promo strip is not
  // worth a flash of chrome that then vanishes.
  //
  // Keyed by the MESSAGE, not by a fixed string, so changing the promo brings
  // the bar back for everyone who dismissed the previous one. Storage is
  // per-viewer and can throw outright in a private window, so every read and
  // write is wrapped and the bar simply shows when it cannot be read.
  (function () {
    var bar = document.querySelector('[data-sticky-promo]');
    if (!bar) return;

    var key = 'macha:promo-dismissed';
    var promo = bar.getAttribute('data-promo-key') || '';

    var stored = null;
    try {
      stored = window.localStorage.getItem(key);
    } catch (e) {
      stored = null;
    }
    if (stored === promo) return;

    bar.hidden = false;

    var button = bar.querySelector('[data-sticky-promo-dismiss]');
    if (!button) return;
    button.addEventListener('click', function () {
      bar.hidden = true;
      try {
        window.localStorage.setItem(key, promo);
      } catch (e) {
        /* dismissed for this view only; it comes back next load */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-popup"]) return;
  try {
    
  (function () {
    const modal = document.querySelector('[data-vip]');
    if (!modal) return;
    const panel = modal.querySelector('[data-vip-panel]');
    const KEY = 'macha:vip-popup';
    let lastFocused = null;

    /* localStorage throws in a private window on some browsers, and a popup is
     * not worth breaking the page over. */
    const seen = () => {
      try { return localStorage.getItem(KEY) === 'done'; } catch (e) { return false; }
    };
    const remember = () => {
      try { localStorage.setItem(KEY, 'done'); } catch (e) { /* nothing to do */ }
    };

    const focusables = () => panel.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    function open() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      const f = focusables();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      modal.hidden = true;
      remember();
      document.removeEventListener('keydown', onKey);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...focusables()];
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-vip-close]')) { e.preventDefault(); close(); }
    });

    /* Straight back up after a successful sign-up, because the panel is where
     * the code is. The success state is detected from the markup rather than a
     * flag on the wrapper: `form.posted_successfully?` only exists INSIDE the
     * form tag, so an attribute on this element would have been a Liquid error
     * — theme check said so on the first build. The code element renders only
     * when the post succeeded, which is the same signal. */
    if (panel.querySelector('.vip__code')) { open(); remember(); return; }

    if (seen()) return;
    const delay = Number(modal.getAttribute('data-delay') || 8) * 1000;
    setTimeout(open, delay);
  }());

  } catch(e) { console.error(e); }
})();
})();
